import { ROLE } from '../../auth'

/**
 * Who changes payment-adapter priorities and routing configs (save, create, reorder, enable, delete): the manager
 * (the admin inherits it) and the merchant manager. The merchant payments operator only reads them — the backend
 * refuses its writes.
 */
export const ADAPTER_PRIORITY_WRITE_ROLES = [ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]

/**
 * Who opens the payment-adapter priority and routing pages (routes and sidebar items): the writers above and the
 * merchant payments operator, which reads them.
 */
export const ADAPTER_PRIORITY_VIEW_ROLES = [
  ROLE.ROLE_ADMIN,
  ROLE.ROLE_MANAGER,
  ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
  ROLE.ROLE_MERCHANT_MANAGER,
]
